<template>
  <main class="home-page" data-test="guest-home-page">
    <div class="center-flex">
      <div class="homepage-content-container">
        <HomePageHeader :first-name="user.firstName" data-test="guest-home-title" />
        <div class="reports-container text-big">
          <div class="reports-header">
            <img
              src="../../assets/dashboards/my-reports-icon.png"
              alt="My Reports"
              class="guest-my-reports-image"
              data-test="guest-my-reports-image"
            />
            <h2>My Reports</h2>
          </div>
          <MyReportsTable data-test="guest-my-reports-table" />
        </div>
        <div
          v-if="isAssessUserWithSolo && hasActiveSubscription"
          class="center-flex repeat-strengths-mapping-container"
        >
          <button
            class="btn btn-repeat-strengths-mapping"
            @click="repeatStrengthsMapping"
            data-test="repeat-strengths-mapping-btn"
          >
            Create new Solo Report
          </button>
        </div>
        <JyreInsightsCard v-if="isAssessUserWithSolo" />
        <div style="height: 50px" />
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import axios from "axios";
import HomePageHeader from "../../components/home-page-header.vue";
import { UserDetailsApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";
import MyReportsTable from "../../components/my-reports/my-reports-table.vue";
import JyreInsightsCard from "../../components/jyre-insights-card.vue";

const user = ref<UserDetailsApiModel>(csContext.user);

const repeatStrengthsMapping = async () => {
  const { request } = await axios.post("/review/reviewyourselfagain");
  if (request?.responseURL.length > 0) {
    window.location.href = request.responseURL;
  }
};

const isAssessUserWithSolo = computed(() => {
  return (
    csContext.userDocument?.platformPermissions.includes("AssessPlanAccess") &&
    csContext.userDocument?.hasCompletedFoundationsSession
  );
});

const hasActiveSubscription = computed(() => {
  return csContext.user.subscriptionLevel === "Full";
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";
@import "../../styles/home-pages/home-pages";

.reports-container {
  margin: 40px 0 80px;

  @media (max-width: @screen-xs-max) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
  }
}

.reports-header {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-bottom: 3rem;

  img {
    height: 100px;
  }
}

.repeat-strengths-mapping-container {
  margin-bottom: 50px;
}

.btn-repeat-strengths-mapping {
  font-size: 18px;
  padding: 10px 16px;
}
</style>
